import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaChartBar, FaHistory, FaArrowUp } from 'react-icons/fa';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const TrendAnalysis = ({ trends }) => {
    const chartData = [
        { name: 'Last Month', value: trends.lastMonth, color: '#666' },
        { name: 'This Month', value: trends.thisMonth, color: '#2a5298' },
        { name: 'This Week', value: trends.thisWeek, color: '#1e3c72' },
        { name: 'Yesterday', value: trends.yesterday, color: '#f39c12' },
        { name: 'Today', value: trends.today, color: '#27ae60' },
    ];

    return (
        <Row className="g-4 mt-2">
            <Col md={8}>
                <Card className="shadow-sm border-0 h-100">
                    <Card.Header className="bg-white border-0 py-3">
                        <h5 className="mb-0 d-flex align-items-center">
                            <FaChartBar className="me-2 text-primary" /> Application Growth Trends
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        <div style={{ width: '100%', height: 300 }}>
                            <ResponsiveContainer>
                                <BarChart data={chartData}>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#666' }} />
                                    <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#666' }} />
                                    <Tooltip
                                        cursor={{ fill: 'transparent' }}
                                        contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                    />
                                    <Bar dataKey="value" radius={[4, 4, 0, 0]} barSize={40}>
                                        {chartData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={4}>
                <Card className="shadow-sm border-0 h-100 bg-light">
                    <Card.Header className="bg-transparent border-0 py-3">
                        <h5 className="mb-0 d-flex align-items-center">
                            <FaHistory className="me-2 text-dark" /> Performance Summary
                        </h5>
                    </Card.Header>
                    <Card.Body className="pt-0">
                        <div className="d-flex flex-column gap-3">
                            <div className="p-3 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
                                <div>
                                    <div className="small text-muted">Today</div>
                                    <h4 className="mb-0 fw-bold text-success">{trends.today}</h4>
                                </div>
                                <div className="text-success small d-flex align-items-center">
                                    <FaArrowUp className="me-1" /> New
                                </div>
                            </div>
                            <div className="p-3 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
                                <div>
                                    <div className="small text-muted">Yesterday</div>
                                    <h4 className="mb-0 fw-bold text-warning">{trends.yesterday}</h4>
                                </div>
                            </div>
                            <div className="p-3 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
                                <div>
                                    <div className="small text-muted">This Week</div>
                                    <h4 className="mb-0 fw-bold text-primary">{trends.thisWeek}</h4>
                                </div>
                            </div>
                            <div className="p-3 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
                                <div>
                                    <div className="small text-muted">This Month</div>
                                    <h4 className="mb-0 fw-bold text-info">{trends.thisMonth}</h4>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default TrendAnalysis;
